import { render, staticRenderFns } from "./CultureBreed.vue?vue&type=template&id=589c6891&"
import script from "./CultureBreed.vue?vue&type=script&lang=js&"
export * from "./CultureBreed.vue?vue&type=script&lang=js&"
import style0 from "./CultureBreed.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CultureBreed.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports